import { render, staticRenderFns } from "./SlideRecommend.vue?vue&type=template&id=01972a29&scoped=true&"
import script from "./SlideRecommend.vue?vue&type=script&lang=js&"
export * from "./SlideRecommend.vue?vue&type=script&lang=js&"
import style0 from "./SlideRecommend.vue?vue&type=style&index=0&id=01972a29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01972a29",
  null
  
)

export default component.exports